import axios from "utils/axios";


/**
 * Повертає список обєктів
 * @param {Object} getData
 * @param {Number} [getData.page]
 * @param {Number} [getData.onPage]
 * @param {string} [getData.search]
 * @param {string} [getData.order]
 * @param {array|null} [getData.status]
 * @returns
 */
export const getList = async (getData) => {
    try {
        const response = await axios('/objects', {params:getData});
        return response?.data||null;
    } catch(e){
        console.error(e);
        return null;
    }
} 


/**
 * Повертає повну інформацію по обєкту
 * @param {Number} objectId 
 * @returns 
 */ 
export const getObject = async (objectId) => {
    try {
        const response = await axios(`/objects/${objectId}`);
        return response.data;
    } catch(e){
        console.error(e);
        return null;
    }
}
  

/**
 * Повертає повну інформацію по видаткам бригади
 * @param {Number} objectId 
 * @param {Number} expendId 
 * @returns 
 */
export const getObjectExpendTeam = async (objectId, expendId) => {
    try {
        const response = await axios(`/objects/expendteam/${objectId}/${expendId}`);
        return response.data;
    } catch(e){
        console.error(e);
        return null;
    }
}

/**
 * Збереження розподілу собівартості послуги між виконавцями
 * @param {Number} objectId
 * @param {Number} expendId
 * @param {{ workers: { userId: number, amount: number, amountRate?: number }[] }} payload
 */
export const saveExpendTeamWorkers = async (objectId, expendId, payload) => {
    try {
        const response = await axios.put(
            `/objects/expendteam/${objectId}/${expendId}/workers`,
            payload,
        );
        return response.data;
    } catch (e) {
        console.error(e);
        return null;
    }
}


/**
 * Повертає повну інформацію по іншим видаткам та надхлодженням
 * @param {Number} objectId 
 * @param {Number} expendId 
 * @returns 
 */
export const getObjectExpend = async (objectId, expendId) => {
    try {
        const response = await axios(`/objects/expend/${objectId}/${expendId}`); 
        return response.data;
    } catch(e){
        console.error(e);
        return null;
    }
}

 
/**
 * Сторення обєкту
 * @param {Number} objectData.clientId
 * @param {Number} objectData.leadId
 * @param {Number} objectData.teamId 
 * @param {string} objectData.objectInfo 
 * @param {Number} objectData.objectPrice 
 * @param {Number} objectData.objectPriceRate 
 * @returns 
 */
export const createObject = async(objectData) => {
    try {   
        const respose = await axios.post('/objects', objectData);
        return respose?.data?.objectId||false;
    } catch(e){
        console.error(e);
        return false;
    }
}

/**
 * Створення складу резерву для об'єкту
 * @param {Number} objectId
 * @returns {Number|false}
 */
export const createReservWarehouse = async (objectId) => {
    try {
        const response = await axios.post(`/objects/${objectId}/reserv-warehouse`);
        return response?.data?.warehouseId || false;
    } catch (e) {
        console.error(e);
        return false;
    }
}


/**
 * Зміна статусу обєкту
 * @param {Number} objectId 
 * @param {Object} status {status, power}
 * @returns 
 */
export const setStatus = async (objectId, statusData) =>{ 
    try {   
        const response = await axios.post(`/objects/status/${objectId}`, statusData);
        return response?.data || { stat: true };
    } catch(e){
        if (e && typeof e === 'object' && ('stat' in e || 'errCode' in e)) {
            return e;
        }
        if (e?.response?.data) return e.response.data;
        console.error(e);
        return { stat: false };
    }
}


/**
 * Прикріплення об'єкта в списку: top | bottom | reset
 * @param {number} objectId
 * @param {'top'|'bottom'|'reset'} action
 * @returns
 */
export const setPin = async (objectId, action) => {
    try {
        const response = await axios.post(`/objects/pin/${objectId}`, { action });
        return response.data.stat;
    } catch (e) {
        console.error(e);
        return false;
    }
};

/**
 * Встановлює "з пдв" режим
 * @param {number} objectId 
 * @param {boolean} isVat 
 * @returns 
 */
export const setVat = async (objectId, isVat) => {
    try {
        const response = await axios.post(`/objects/vat/${objectId}`, {isVat});
        return response.data.stat;
    } catch(e){
        console.error(e);
        return false;
    }
}

/**
 * Статус оплати об'єкта: 0 — не оплачено, 1 — частково, 2 — оплачено
 */
export const setPayStatus = async (objectId, payStatus) => {
    try {
        const response = await axios.post(`/objects/pay-status/${objectId}`, { payStatus });
        return response?.data?.stat || false;
    } catch (e) {
        console.error(e);
        return false;
    }
};

/**
 * Синхронізує статус оплати об'єкта за документами: 0 / 1 (частково) / 2 (оплачено)
 * @returns {{ updated: boolean, payStatus: number } | null}
 */
export const syncPayStatusIfCovered = async (objectId) => {
    try {
        const response = await axios.post(`/objects/pay-status/sync/${objectId}`);
        return response?.data || null;
    } catch (e) {
        console.error(e);
        return null;
    }
};

/**
 * Історія зміни ціни об'єкту
 * @param {Number} objectId
 * @returns {Array|null}
 */
export const getPriceHistory = async (objectId) => {
    try {
        const response = await axios(`/objects/${objectId}/history-price`);
        return response?.data?.history || null;
    } catch (e) {
        console.error(e);
        return null;
    }
};

/**
 * Зміна ціни об'єкту
 * @param {Number} objectId
 * @param {Object} priceData
 * @param {Number} priceData.objectPrice
 * @param {Number} priceData.objectPriceRate
 * @param {string} [priceData.comment]
 * @returns {{stat: boolean, errCode?: string, objectPrice?: number, objectPriceRate?: number}|null}
 */
export const setObjectPrice = async (objectId, priceData) => {
    try {
        const response = await axios.post(`/objects/${objectId}/price`, priceData);
        return response?.data || null;
    } catch (e) {
        if (e?.response?.status === 403) return { stat: false, errCode: 'FORBIDDEN' };
        if (e?.response?.data) return e.response.data;
        console.error(e);
        return { stat: false };
    }
};


/**
 * Зміна назви обєкту
 * @param {number} objectId 
 * @param {string} objectName 
 * @returns 
 */
export const setName = async (objectId, objectName) => {
    try {
        const response = await axios.post(`/objects/name/${objectId}`, {objectName})
        return response.data.stat;
    } catch(e){
        console.log(e);
        return false;
    }
}


/**
 * Зміна бригати для обєкту
 * @param {Number} objectId 
 * @param {Number} teamId 
 */
export const setTeam = async(objectId, teamId) => {
    try {   
        const respose = await axios.post(`/objects/team/${objectId}/${teamId}`);
        return respose?.data?.stat||false
    } catch(e){
        console.error(e);
        return false;
    }
} 
  

/**
 * Зміна дедлайну по обєкту
 * @param {Number} objectId 
 * @param {Number} deadLine 
 * @returns 
 */
export const setDeadLine = async (objectId, deadLine) => {
    try {
        const respose = await axios.post(`/objects/deadline/${objectId}/${deadLine}`);
        return respose?.data?.stat||false
    } catch(e){
        console.error(e);
        return false;
    }
}


/**
 * Зміна Дати створення обєкту
 * @param {Number} objectId 
 * @param {Number} createdDate 
 * @returns 
 */
export const setCreated = async (objectId, createdDate) => {
    try {
        const respose = await axios.post(`/objects/created/${objectId}/${createdDate}`);
        return respose?.data?.stat||false
    } catch(e){
        console.error(e);
        return false;
    }
}


/**
 * Зміна Дати заркиттґ обєкту
 * @param {Number} objectId 
 * @param {Number} createdDate 
 * @returns 
 */
export const setFinished = async (objectId, createdDate) => {
    try {
        const respose = await axios.post(`/objects/finished/${objectId}/${createdDate}`);
        return respose?.data?.stat||false
    } catch(e){
        console.error(e);
        return false;
    }
}



/**
 * Зміна опису обєкту
 * @param {Number} objectId 
 * @param {Number} deadLine 
 * @returns 
 */
export const setInfo = async (objectId, objectInfo) => {
    try {
        const respose = await axios.post(`/objects/info/${objectId}`, {objectInfo});
        return respose?.data?.stat||false
    } catch(e){
        console.error(e);
        return false;
    }
}

/**
 * Зміна даних замовника обєкту
 * @param {Number} objectId
 * @param {Object} objectCustomer
 * @returns
 */
export const setCustomer = async (objectId, objectCustomer) => {
    try {
        const response = await axios.post(`/objects/customer/${objectId}`, { objectCustomer });
        if (!response?.data?.stat) return { stat: false };
        const clientCustomerId = Number(response.data.clientCustomerId || 0);
        return {
            stat: true,
            clientCustomerId: clientCustomerId > 0 ? clientCustomerId : undefined,
        };
    } catch (e) {
        console.error(e);
        return { stat: false };
    }
}

/**
 * Проксі YouControl: сирі дані компанії по ЄДРПОУ / ІПН
 * @param {string} companyCode
 * @returns {Promise<Object|null>}
 */
export const getYouControlCompany = async (companyCode) => {
    try {
        const code = String(companyCode || '').trim();
        if (!code) return null;
        const response = await axios(`/objects/youcontrol/${encodeURIComponent(code)}`);
        return response?.data || null;
    } catch (e) {
        console.error(e);
        return null;
    }
};

/**
 * Зміна специфікації обєкту
 * @param {Number} objectId
 * @param {Object} objectDetails
 * @returns
 */
export const setDetails = async (objectId, objectDetails) => {
    try {
        const response = await axios.post(`/objects/details/${objectId}`, { objectDetails });
        return response?.data?.stat || false;
    } catch (e) {
        console.error(e);
        return false;
    }
}
 

/**
 * Додаємо видатки за послуги на бригаду
 * @param {Object} expendData
 */
export const addExpendTeam = async (expendData) =>{
    try {
        const response = await axios.post(`/objects/expendteam`, expendData);
        return response.data.stat;
    } catch(e){
        console.error(e);
        return false;
    }
}

/**
 * Зміна собівартості та ціни продажу послуги на бригаду
 * @param {Number} expendId
 * @param {{ price: number, priceSale: number }} priceData
 */
export const setExpendTeamPriceSale = async (expendId, priceData) => {
    try {
        const response = await axios.post(`/objects/expendteam/price/sale/${expendId}`, priceData);
        return response.data.stat;
    } catch (e) {
        console.error(e);
        return false;
    }
}
 

/** 
 * Додаємо видатки або надходення
 * @param {Object} expendData  {teamId, objectId, amount, amountRate, description}
 */
export const addExpend = async (expendData) =>{ 
    try {
        const response = await axios.post(`/objects/expend`, expendData);
        return response.data.stat;
    } catch(e){
        console.error(e);
        return false;
    }
}


/**
 * Відміна операції видатків по бригаді
 * @param {Number} expendId 
 * @returns 
 */
export const cancelExpendTeam = async (expendId) => {
    try {
        const response = await axios.delete(`/objects/expendteam/${expendId}`);
        return response.data.stat;
    } catch(e){
        console.error(e);
        return false;
    }
}

/**
 * Відміна операції видатків по бригаді
 * @param {Number} expendId 
 * @returns 
 */
export const cancelExpend = async (expendId) => {
    try {
        const response = await axios.delete(`/objects/expend/${expendId}`);
        return response.data.stat;
    } catch(e){
        console.error(e);
        return false;
    }
}


/**
 * Зміна Дати видатку на бригаду
 * @param {Number} expendId 
 * @param {Number} expendDate 
 * @returns 
 */
export const setExpendTeamDate = async (expendId, expendDate) => {
    try {
        const respose = await axios.post(`/objects/expendteam/date/${expendId}/${expendDate}`);
        return respose?.data?.stat||false
    } catch(e){
        console.error(e);
        return false;
    }
}
